import firebase from "firebase";
import moment from "moment";
import { deleteFile, uploadFileAsync } from "../../helpers/UploadFile";
import {
  loadResponseTimesParamsForm,
  deleteAnnotationDb,
  setAnnotationDb,
  updateResponseTimes,
  setCorrespondenceDb,
  setEditCorrespondenceDb,
  addExternalSender,
  loadExternalSenders,
  deleteCommunicationDb,
  getCorrespondenceInbox,
  getMilestones,
  setContractingOfficeDb,
  getContractingOffice,
  deleteFileCorrespondence,
  loadTenders,
  addMilestoneDb,
  addOrUpdateTender,
  loadProductionOfficeParam,
  addCorrespondenceTender,
  startListenerCorrespondencesByEntity,
  loadMoreCorrespondencesByEntity,
  loadAllCorrespondencesByEntity,
  sendEmailNotification,
  startListenerAnnotations,
  setLabelSizeDb,
  loadLabelSizeDb,
  getLastCorrespondence,
  updateFilesCorrespondence,
  updateFilesAnswerCorrespondence,
  searchExternalSendersBySearchTermAndIdEntity,
  getCorrespondenceSection,
  createMilestone,
  FilesCorrespondencedigitalSupportTrd,
  geCorrespondenceById,
  FilesCorrespondenceAppendDocsTrd,
} from "../../services/firebase/correspondence";
import { AppState } from "../reducers/rootReducer";
import {
  IAnnotation,
  ICorrespondenceActions,
  Types,
  IParamProcedure,
  IParamResponseTime,
  IFiles,
  IExternalSender,
  IMilestones,
  IContractingOffice,
  ILabelSize,
  IRecipients,
  IUserLoggedIn,
  IFilesAppendDocs,
} from "../types/types";
import {
  setErrorMsg,
  setSuccessMsg,
  uiCloseModalAdd,
  uiCloseModalDelete,
  uiOpenErrorAlert,
  uiOpenSuccessAlert,
  uiCloseModalSee,
  uiCloseModalEdit,
  uiCloseModalAction,
  uiCloseModalAnswer,
  uiCloseModalInfo,
  uiCloseModalNull,
} from "./uiActions";
import { randomNumber } from "../../helpers/randomNumber";
import {
  ICorrespondence,
  ICorrespondenceInfo,
  ITenderCorrespondence,
} from "../../interfaces/Correspondence";
import { createIncrementalCode } from "../../helpers/incrementalCode";
import {
  CommunicationChannels,
  CommunicationChannelsList,
  CorrespondenceInputType,
  CorrespondenceStatus,
  Enum_Notification_Type,
  InternalCorrespondenceStatus,
} from "../../enums/enums";
import {
  ITenders,
  IProponent,
  ICorrespondenceResponse,
} from "../../interfaces/Correspondence";
import { uiOpenAlertExists } from "./uiActions";
import { getFuidMilestones } from "../../services/firebase/fuid";
import {
  IEmailNotificationParams,
  IEmailParamDataEr,
  IEmailStatus,
  IUserSendEmail,
} from "../../interfaces/emailNotification";
import {
  getEntityById,
  getDataFromEntities,
} from "../../services/firebase/entities";
import { setActiveExternalSender } from "../../module/admin/redux/actions/usersActions";
import {
  getCopyArrayOrObject,
  getCurrentDateAndHourColombia,
  getDateToTimeZoneServer,
} from "../../utils/utils";
import {
  IEmailParamDataEp,
  IFormSendEmail,
} from "../../interfaces/emailNotification";
import { addCorrespondenceResponse } from "../../services/firebase/correspondence";
import { fetchCompanyData } from "./entityLoadActions";
import { IntlShape } from "react-intl";
import { saveFilesFirebase } from "../../utils/uploadFile/service/uploadFileToFireBase";
import { create } from "../../services/firebase/file-service";
import { IClassificationTrdDoc } from "../../module/documentManagment/doc/IClassificationTrdDoc";
import { IClassificationTrdDigitalSupport } from "../../module/documentManagment/doc/IClassificationTrdDigitalSupport";
import { IClassificaitionTrd } from "../../module/documentManagment/doc/IClassificaitionTrd";
import { IClassificationTrdFileDoc } from "../../module/documentManagment/doc/IClassificationTrdFileDoc";
import { setActiveCorrespondenceDocManagment } from "./documentManagmentActions";
import { SpecialDay } from "../../module/superAdmin/form/SpecialDay";
import { WorkScheduleFormValues } from "../../module/superAdmin/form/WorkScheduleFormValues";
import { downloadFileFirebase } from "../../helpers/downloadFileFirebase";

export const startLoadAnnotations = (idEntity: string) => {
  return async (dispatch: Function) => {
    startListenerAnnotations(idEntity, dispatch);
  };
};
export const purgeCorrespondence = (): ICorrespondenceActions => ({
  type: Types.purgeCorrespondence,
});

export const loadAnnotations = (
  annotations: IAnnotation[]
): ICorrespondenceActions => ({
  type: Types.loadAnnotations,
  payload: annotations,
});
export const startSetAnnotation = (annotation: IAnnotation, edit: boolean) => {
  return async (dispatch: Function, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      if (annotation.attachedDocument && annotation.attachedDocument.file) {
        const urlFile = await uploadFileAsync(
          annotation.attachedDocument.file,
          `annotations/${user.idEntity}/${annotation.attachedDocument.fileName}`
        );
        annotation.attachedDocument = {
          fileName: annotation.attachedDocument.fileName,
          url: urlFile,
        };
      }
      const { ok } = await setAnnotationDb(user.idEntity, annotation);
      if (ok) {
        dispatch(setAnnotation(annotation));
        dispatch(uiCloseModalAdd());
        dispatch(
          setSuccessMsg(edit ? "UpdatedCommunication" : "CreatedCommunication")
        );
        dispatch(uiOpenSuccessAlert());
        dispatch(setActiveAnnotation(null));
      } else {
        dispatch(setErrorMsg("SavingDataError"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};
export const setAnnotation = (
  annotation: IAnnotation
): ICorrespondenceActions => ({
  type: Types.setAnnotation,
  payload: annotation,
});
export const setActiveAnnotation = (
  active: IAnnotation | null
): ICorrespondenceActions => ({
  type: Types.setActiveAnnotation,
  payload: active,
});

export const startDeleteAnnotation = () => {
  return async (dispatch: Function, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    const { activeAnnotation } = (getState() as AppState).correspondence;

    if (user && user.idEntity && activeAnnotation) {
      const { ok } = await deleteAnnotationDb(
        user.idEntity,
        activeAnnotation.id,
        activeAnnotation.recipientsData,
        activeAnnotation.attachedDocument
      );
      if (ok) {
        dispatch(deleteAnnotation(activeAnnotation.id));
        dispatch(uiCloseModalDelete());
        dispatch(setActiveAnnotation(null));
        dispatch(setSuccessMsg("DeletedAnnotation"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("DeletingError"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};
const deleteAnnotation = (idAnnotation: string): ICorrespondenceActions => ({
  type: Types.deleteAnnotation,
  payload: idAnnotation,
});

// *****************    PARAMETRIZACIÓN    *****************

export const startLoadProductionOfficeParam = (idEntity: string) => {
  return async (dispatch: Function) => {
    const producOffParam = await loadProductionOfficeParam(idEntity);
    if (producOffParam) {
      dispatch(setProductionOfficeParam(producOffParam));
    }
  };
};
const setProductionOfficeParam = (office: string): ICorrespondenceActions => ({
  type: Types.setProductionOfficeParam,
  payload: office,
});

// ****************   PARAMETRIZACIÓN - tiempos de respuesta    ******************
// cargar parametros del formulario de tiempo de respuesta
export const startLoadingResponseTimesParams = (idEntity: string) => {
  return async (dispatch: Function) => {
    const ResponseTimesParamsForm = await loadResponseTimesParamsForm(idEntity);
    dispatch(setResponseTimesParamsForm(ResponseTimesParamsForm));
  };
};

// setear parametros del formulario de tiempo de respuesta
export const setResponseTimesParamsForm = (form: IParamResponseTime | any) => ({
  type: Types.loadParamsResponseTime,
  payload: form,
});

// actualizar formulario de respuestas
export const updateResponseTimesForm = (form: IParamResponseTime) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { ok } = await updateResponseTimes(idEntity, form);
    if (ok) {
      await dispatch(setResponseTimesParamsForm(form));
      dispatch(setSuccessMsg("FormResponseTimesUpdated"));
      dispatch(uiOpenSuccessAlert());
    } else {
      dispatch(setErrorMsg("ErrorProcedureUpdate"));
      dispatch(uiOpenErrorAlert());
    }
  };
};

// -------------------------------- CORRESPONDENCE ACTIONS ------------------------

export const startLoadCorrespondences = (idUser: number, idEntity: string) => {
  return async (dispatch: any) => {
    startListenerCorrespondencesByEntity(idEntity, idUser.toString(), dispatch);
  };
};

export const startLoadMoreCorrespondences = (idUser: number, idEntity: string) => {
  return async (dispatch: any, getState: Function) => {
    const { correspondencePagination } = (getState() as AppState).correspondence;
    if (!correspondencePagination.hasMore || correspondencePagination.isLoadingMore || !correspondencePagination.lastVisible) {
      return;
    }
    dispatch({
      type: Types.setCorrespondencePagination,
      payload: { isLoadingMore: true },
    });
    await loadMoreCorrespondencesByEntity(
      idEntity,
      idUser.toString(),
      correspondencePagination.lastVisible,
      dispatch
    );
  };
};

export const startLoadAllCorrespondences = (idUser: number, idEntity: string) => {
  return async (dispatch: any, getState: Function) => {
    const { correspondencePagination } = (getState() as AppState).correspondence;
    if (correspondencePagination.isLoadingMore) {
      return;
    }
    dispatch({
      type: Types.setCorrespondencePagination,
      payload: { isLoadingMore: true },
    });
    await loadAllCorrespondencesByEntity(
      idEntity,
      idUser.toString(),
      correspondencePagination.lastVisible,
      dispatch
    );
  };
};

export const loadCorrespondeces = (
  correspondences: ICorrespondence[]
): ICorrespondenceActions => ({
  type: Types.loadCorrespondences,
  payload: correspondences,
});

export const updateFirstPageCorrespondeces = (
  correspondences: ICorrespondence[]
): ICorrespondenceActions => ({
  type: Types.updateFirstPageCorrespondences,
  payload: correspondences,
});

// FUNCION PARA EDITAR ADDRESSEE Y GIVEBACK CUANDO SE RETORNA LA CORRESPONDENCIA
export const editCorrespondenceReturn = (correspondence: ICorrespondence) => {
  return async (dispatch: any, getState: Function) => {
    correspondence.addressee = { id: "", name: "" };
    correspondence.isGiveBack = true;
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      const { ok } = await setEditCorrespondenceDb(
        correspondence,
        user.idEntity
      );
      if (ok) {
        //TODO
        //AGREGAR AL MILESTONE
        await addMilestoneDb(
          user.idEntity,
          correspondence.id,
          firebase.firestore.Timestamp.now(),
          `Devuelto a módulo correspondencia`,
          user.id,
          user.names
        );
        dispatch(setCorrespondence(correspondence));
      }
    }
  };
};

const getLastConsecutive = async (idEntity: string) => {
  const lastCorrespondence = await getLastCorrespondence(idEntity);
  let lastConsecutive = "0";
  if (lastCorrespondence) {
    lastConsecutive = lastCorrespondence.id.substring(
      lastCorrespondence.id.length - 9
    );
  }
  return lastConsecutive;
};

export const startSetCorrespondence = (
  correspondenceForm: ICorrespondence,
  edit: boolean,
  deleteFile: boolean,
  tdr?: boolean,
  isFinalAnswer?: boolean,
  howToSendEmail?: string,
  intl?: IntlShape,
  specialDays?: any[],
  scheduleData?: any
) => {
  return async (dispatch: any, getState: Function) => {
    // CUANDO EL TIPO DE ENTRADA SEA IP O IR HAY QUE RADICAR 2 VECES CON LAS CORRESPONDIENTES DEPENDENCIAS
    // armar el id/radicado
    // TIPO CANAL+TIPO ENTRADA+AÑO+ULTIMA VERSION DE LA TRD+NUMERO CONSECUTIVO DE 9 DIGITOS
    // para hacer el numero consecutivo por año hay que tomar le tamaño del arr de correspondencia y validar si en el actual año no se han creado correspondencias arranca desde 0
    const { versions, productionOffices } = (getState() as AppState).trd;
    const { initialSettled } = (getState() as AppState).entities;
    const { user } = (getState() as AppState).auth;
    const { users, externalSenders } = (getState() as AppState).users;
    const { companyData } = (getState() as AppState).entityLoad;

    const allUsers = users.concat(externalSenders as any);
    const currentTrdVersion = versions.length > 0 ? versions[0] : null;
    const correspondence = { ...correspondenceForm };
    let savedFiles: IFiles[] = [];

    if (!correspondence.specialDay) {
      correspondence.specialDay = [] as SpecialDay[];
    }
    if (!correspondence.workScheduleFormValues) {
      correspondence.workScheduleFormValues = {
        days: Array(7).fill({
          startTime: null,
          endTime: null,
          isWorkingDay: false,
        }),
        restrictOutsideWorkHours: false,
      } as WorkScheduleFormValues;
    }

    const { communicationChannel, inputType } = correspondence;

    if (!initialSettled) {
      dispatch(setErrorMsg("WarningInitialSetled"));
      dispatch(uiOpenErrorAlert());

      dispatch(uiCloseModalAdd());
      return dispatch(uiCloseModalEdit());
    }

    if (!currentTrdVersion || !user || !user.idEntity || !user.username) {
      throw new Error("falta de información del usuario ");
    }
    dispatch(fetchCompanyData(user.idEntity));

    let incrementalCode = createIncrementalCode(parseInt(initialSettled));

    const lastConsecutive = await getLastConsecutive(user.idEntity);
    if (lastConsecutive !== "0") {
      incrementalCode = createIncrementalCode(
        parseInt(lastConsecutive, 10) + 1
      );
    }

    let timeCompany = await getDateToTimeZoneServer(companyData.country);
    correspondence.createAt = edit ? correspondence.createAt : timeCompany;

    if (correspondence.communicationType?.option === "Informativo") {
      correspondence.internalState =
        InternalCorrespondenceStatus.NO_ANSWER_REQUIRED;
      correspondence.responseTimeDays = null;
    }

    switch (inputType) {
      case CorrespondenceInputType.ER:
        correspondence.specialDay = specialDays;
        correspondence.workScheduleFormValues = scheduleData;
        let correspondenceEr = await correspondenceErStructure(
          correspondence,
          incrementalCode,
          edit,
          dispatch
        );
        correspondenceSaveFile(correspondence, null, user, correspondenceEr.id);
        correspondenceSaveDb(
          correspondenceEr,
          user,
          edit,
          dispatch,
          timeCompany
        );
        break;

      case CorrespondenceInputType.EP:
        let correspondenceEp = await correspondenceEpStructure(
          correspondence,
          incrementalCode,
          edit,
          dispatch
        );

        savedFiles = await correspondenceSaveFile(
          correspondence,
          null,
          user,
          correspondenceEp.id
        );
        correspondenceSaveDb(
          correspondenceEp,
          user,
          edit,
          dispatch,
          timeCompany
        );
        break;

      case CorrespondenceInputType.IR:
        // console.log("IR");
        let temFileir = correspondence.digitalSupport;
        let getCorrespondenceIr = await correspondenceIrStructure(
          correspondence,
          edit,
          user,
          dispatch
        );

        getCorrespondenceIr.specialDay = specialDays;
        getCorrespondenceIr.workScheduleFormValues = scheduleData;

        //consulta codigo de ip
        let getCorrespondenceIpCode = await getCorrespondenceSection(
          getCorrespondenceIr.idEntity,
          getCorrespondenceIr.id
        );

        // repucera documento de ip
        let getCorrespondenceIp = await getCorrespondenceSection(
          correspondence.idEntity,
          getCorrespondenceIpCode.correspondenceIpIr
        );

        let correspondenceIpEst = await correspondenceIpStructure(
          getCorrespondenceIp,
          incrementalCode,
          edit,
          user,
          dispatch
        );

        // guarda la informacion del file
        correspondenceSaveFile(
          correspondence,
          correspondenceIpEst,
          user,
          getCorrespondenceIr.id
        );
        correspondenceIpEst.digitalSupport = temFileir;
        correspondenceSaveFile(
          correspondenceIpEst,
          getCorrespondenceIr,
          user,
          correspondenceIpEst.id
        );

        // guarda los datos en db
        // console.log(getCorrespondenceIr, "getCorrespondenceIr");
        correspondenceSaveDb(
          getCorrespondenceIr,
          user,
          edit,
          dispatch,
          timeCompany
        );
        // console.log(correspondenceIpEst, "correspondenceIpEst,");
        correspondenceSaveDb(
          correspondenceIpEst,
          user,
          edit,
          dispatch,
          timeCompany
        );

        break;

      case CorrespondenceInputType.IP:
        // console.log("IP");
        let temFileip = correspondence.digitalSupport;

        let _correspondenceIp = await correspondenceIrStructure(
          correspondence,
          edit,
          user,
          dispatch
        );

        // guarda la informacion del ip

        //consutla codigo de ir
        let correspondenceIrCode = await getCorrespondenceSection(
          _correspondenceIp.idEntity,
          _correspondenceIp.id
        );

        // repuera documento de ir
        let _correspondenceIr = await getCorrespondenceSection(
          correspondence.idEntity,
          correspondenceIrCode.correspondenceIpIr
        );

        let correspondenceIrEst = await correspondenceIpStructure(
          _correspondenceIr,
          incrementalCode,
          edit,
          user,
          dispatch
        );

        // guarda laos datos de los file
        correspondenceSaveFile(
          correspondence,
          correspondenceIrEst,
          user,
          _correspondenceIp.id
        );
        correspondenceIrEst.digitalSupport = temFileip;
        correspondenceSaveFile(
          correspondenceIrEst,
          _correspondenceIp,
          user,
          correspondenceIrEst.id
        );
        // guarda la informacion en db
        // console.log("correspondenceIrEst", correspondenceIrEst);
        correspondenceSaveDb(
          correspondenceIrEst,
          user,
          edit,
          dispatch,
          timeCompany
        );
        // console.log("_correspondenceIp", _correspondenceIp);
        correspondenceSaveDb(
          _correspondenceIp,
          user,
          edit,
          dispatch,
          timeCompany
        );

        break;

      case CorrespondenceInputType.IPR: {
        const correspondenceIp = await correspondenceIpStructure(
          correspondence,
          incrementalCode,
          edit,
          user,
          dispatch
        );

        if (specialDays && specialDays.length > 0) {
          correspondence.specialDay = specialDays;
          correspondence.workScheduleFormValues = scheduleData;
        }

        const correspondenceIr = await correspondenceIrStructure(
          correspondence,
          edit,
          user,
          dispatch
        );

        savedFiles = await correspondenceSaveFile(
          correspondence,
          correspondenceIp,
          user,
          correspondenceIr.id
        );

        await updateFilesCorrespondence(
          savedFiles,
          user.idEntity,
          correspondenceIp.id
        );

        correspondenceIr.correspondenceIpIr = correspondenceIp.id;
        correspondenceIp.correspondenceIpIr = correspondenceIr.id;

        correspondenceIp.digitalSupport = savedFiles;
        correspondenceIr.digitalSupport = savedFiles;

        await correspondenceSaveDb(
          correspondenceIp,
          user,
          edit,
          dispatch,
          timeCompany
        );
        await correspondenceSaveDb(
          correspondenceIr,
          user,
          edit,
          dispatch,
          timeCompany
        );

        if (isFinalAnswer && correspondence.answer) {
          const objAnswer: ICorrespondenceResponse = {
            ...correspondence.answer,
            submitDate: firebase.firestore.Timestamp.now(),
            officer: {
              id: user.id.toString(),
              name: user.username,
            },
            isScreeningAnswer: false,
          };

          await addCorrespondenceResponse(
            user.idEntity,
            correspondenceIr.id,
            objAnswer
          );
          await addCorrespondenceResponse(
            user.idEntity,
            correspondenceIp.id,
            objAnswer
          );
        }

        if (!deleteFile) {
          if (isFinalAnswer) {
            await updateFilesAnswerCorrespondence(
              savedFiles,
              user.idEntity,
              correspondenceIp.id
            );
            await updateFilesAnswerCorrespondence(
              savedFiles,
              user.idEntity,
              correspondenceIr.id
            );
            return correspondence;
          }
          successMsg(dispatch, edit);
          dispatch(uiOpenSuccessAlert());
        }
        manejoModal(dispatch, tdr);
        break;
      }

      default:
        // console.log("default");
        correspondenceSaveDb(correspondence, user, edit, dispatch, timeCompany);
        correspondenceSaveFile(correspondence, null, user, correspondence.id);
        //  dispatch(uiOpenErrorAlert());
        break;
    }

    if (isFinalAnswer) {
      const { ok } = await updateFilesAnswerCorrespondence(
        { ...savedFiles },
        user.idEntity,
        correspondence.id
      );
      if (!ok) {
        await updateFilesAnswerCorrespondence(
          { ...savedFiles },
          user.idEntity,
          correspondence.id
        );
      }
      return correspondence;
    }

    //CONDICIONAL CON EL TIPO DE ENTRADA PARA PODER MANDAR EL CORREO EP o ER
    const addresseFind = (allUsers as any[]).find(
      (user) =>
        user.id === parseInt(correspondence.addressee.id) ||
        user?.idDoc === correspondence.addressee?.idDoc
    );

    const senderFind = (allUsers as any[]).find(
      (user) =>
        user.id === parseInt(correspondence.externalSender.id) ||
        user.idDoc === correspondence.externalSender.id
    );

    if (addresseFind && senderFind && senderFind.email.length > 0) {
      //const { address } = addresseFind;

      const officeFind = productionOffices.find((office) => {
        return office.id === correspondence.receivingDependency; // Ajusta las condiciones según tus necesidades
      });

      if (officeFind) {
        if (correspondence.inputType === CorrespondenceInputType.ER) {
          let communicationChannelName = CommunicationChannelsList.find(
            (channel) => channel.value === communicationChannel
          )?.name;

          communicationChannelName = intl?.formatMessage({
            id: communicationChannelName,
          });

          const entity = await getEntityById(addresseFind.idEntity);
          const { emailSender } = await getDataFromEntities(
            entity.idEntity.toString()
          );
          const emailParamsEr: IEmailParamDataEr = {
            addresse: addresseFind.username
              ? addresseFind.username
              : addresseFind.name,
            createAt: moment().format("YYYY/MM/DD hh:mm a"),
            entity: entity.businessName,
            entityId: user.idEntity,
            sender: senderFind.username ? senderFind.username : senderFind.name,
            settled: correspondence.id,
            channel: communicationChannelName!,
            emailCommunication: emailSender,
          };

          const totalParams: IEmailNotificationParams = {
            type: Enum_Notification_Type.ER,
            data: emailParamsEr,
            email: senderFind.email, //enviar correo al remitente externo
            emailSender: entity.emailSender,
            emailMailjet: entity.emailMailjet,
            entityName: entity.businessName,
            // emailSender: "comercial@appsus.co",
          };

          if (!edit) {
            const { entityId, settled } = totalParams.data as any;
            totalParams.urlCorrespondenceStatus = `${process.env.REACT_APP_MAIN_URL}procedure-status/${entityId}/${settled}`;
            await sendEmailNotification(totalParams);
          }
        } else if (
          correspondence.inputType === CorrespondenceInputType.EP &&
          howToSendEmail === "1"
        ) {
          const emailSender = await getDataFromEntities(senderFind.idEntity);
          const entity = await getEntityById(correspondence.idEntity);
          const addresseFindExternal = (allUsers as any[]).find(
            (user) =>
              user.id === parseInt(correspondence.addressee.id) ||
              user.idDoc === correspondence.addressee.id
          );

          const emailParamsEp: IEmailParamDataEp = {
            addresse: {
              name: addresseFindExternal.username
                ? addresseFindExternal.username
                : addresseFindExternal.name,
              address: addresseFindExternal.address,
              city: addresseFindExternal.city,
              phone: addresseFindExternal.mobilePhone
                ? addresseFindExternal.mobilePhone
                : addresseFindExternal.phone,
              id: addresseFindExternal.username
                ? addresseFindExternal.id.toString()
                : addresseFindExternal.id,
            },
            createAt: moment().format("YYYY/MM/DD hh:mm a"),
            description: correspondence.description,
            entity: {
              name: entity.businessName,
              address: entity.address,
              phone: entity.phone,
              city: entity.town,
              id: entity.id,
            },
            files: savedFiles,
            sender: {
              name: senderFind.username ? senderFind.username : senderFind.name,
              office: officeFind.name,
            },
            settled: correspondence.id,
            subject: correspondence.subject,
            email: emailSender.emailSender,
          };

          const totalParams: IEmailNotificationParams = {
            type: Enum_Notification_Type.EP,
            data: emailParamsEp,
            email: addresseFindExternal.email, //enviar correo al destinatario
            emailSender: entity.emailSender,
            emailMailjet: entity.emailMailjet,
            entityName: entity.businessName,
          };

          const response = !edit
            ? ((await sendEmailNotification(totalParams)) as unknown as any)
            : null;
          if (response.ok) {
            const messageId =
              response?.data?.body?.Messages[0]?.To[0]?.MessageUUID ?? "";

            const status: IEmailStatus[] = initEmailState();
            //mandar al historial
            const userSendEmail: IUserSendEmail = {
              email: addresseFindExternal.email,
              id: correspondence.idEntity,
            };
            const emailData: IFormSendEmail = {
              addressee: userSendEmail,
              copyTo: [],
              files: correspondence.digitalSupport,
            };
            const answerMsg = `Enviado al correo electrónico ${addresseFindExternal.email}`;
            const objAnswer: ICorrespondenceResponse = {
              subject: answerMsg,
              submitDate: firebase.firestore.Timestamp.now(),
              officer: { id: user.id.toString(), name: user.username },
              isScreeningAnswer: false,
              isSendEmailResponse: true,
              emailData: emailData,
              status,
              messageId,
            };
            await addCorrespondenceResponse(
              user.idEntity,
              correspondence.id,
              objAnswer
            );
          }
        }
      }
    }

    if (!deleteFile) {
      manejoModal(dispatch, tdr);
      successMsg(dispatch, edit);
      dispatch(uiOpenSuccessAlert());
      //loadCorrespondencesByEntity(user.idEntity);
    }

    dispatch(setActiveCorrespondence(null));
  };
};

const correspondenceIpStructure = async (
  correspondence: ICorrespondence,
  incrementalCode: string,
  edit: boolean,
  user: IUserLoggedIn,
  dispatch: any
) => {
  try {
    const correspondenceCopyIP = getCopyArrayOrObject(correspondence);
    correspondenceCopyIP.createAt = correspondence.createAt;

    if (!user.idEntity || !user.username) {
      dispatch(uiOpenErrorAlert());

      throw new Error("falta de información del usuario Ip");
    }

    const officeCodeIP = correspondenceCopyIP.producerDependency
      ? correspondenceCopyIP.producerDependency.split("_", 1)
      : "";

    const fullSettledCodeIp = edit
      ? correspondenceCopyIP.id
      : correspondenceCopyIP.communicationChannel +
        CorrespondenceInputType.IP +
        moment().format("YYYY") +
        officeCodeIP +
        incrementalCode;

    correspondenceCopyIP.id = fullSettledCodeIp;
    correspondenceCopyIP.inputType = CorrespondenceInputType.IP;
    correspondenceCopyIP.internalState =
      InternalCorrespondenceStatus.NO_ANSWER_REQUIRED;
    correspondence.status = CorrespondenceStatus.RESOLVED;

    return correspondenceCopyIP;
  } catch (error) {
    dispatch(uiOpenErrorAlert());
    throw new Error("Error save Ip");
  }
};

const correspondenceIrStructure = async (
  correspondence: ICorrespondence,
  edit: boolean,
  user: IUserLoggedIn,
  dispatch: any
) => {
  try {
    const correspondenceCopyIR = getCopyArrayOrObject(correspondence);
    correspondenceCopyIR.createAt = correspondence.createAt;

    if (!user.idEntity || !user.username) {
      dispatch(uiOpenErrorAlert());
      throw new Error("falta de información del usuario Ir");
    }
    const officeCodeIR = correspondenceCopyIR.receivingDependency.split("_", 1);

    const lastConsecutive = await getLastConsecutive(user.idEntity);
    const fullSettledCodeIR = edit
      ? correspondenceCopyIR.id
      : correspondenceCopyIR.communicationChannel +
        CorrespondenceInputType.IR +
        moment().format("YYYY") +
        officeCodeIR +
        createIncrementalCode(parseInt(lastConsecutive, 10) + 1);

    correspondenceCopyIR.id = fullSettledCodeIR;
    correspondenceCopyIR.inputType = CorrespondenceInputType.IR;

    return correspondenceCopyIR;
  } catch (error) {
    dispatch(uiOpenErrorAlert());
    throw new Error("Error save Ir");
  }
};

const correspondenceEpStructure = async (
  correspondence: ICorrespondence,
  incrementalCode: string,
  edit: boolean,
  dispatch: any
) => {
  try {
    const officeCodeEP = correspondence.receivingDependency
      ? correspondence.receivingDependency.split("_", 1)
      : "";

    const fullSettledCode = edit
      ? correspondence.id
      : correspondence.communicationChannel +
        CorrespondenceInputType.EP +
        moment().format("YYYY") +
        officeCodeEP +
        incrementalCode;
    correspondence.id = fullSettledCode;

    return correspondence;
  } catch (error) {
    dispatch(uiOpenErrorAlert());
    throw new Error("Error save Ep");
  }
};

const correspondenceErStructure = async (
  correspondence: ICorrespondence,
  incrementalCode: string,
  edit: boolean,
  dispatch: any
) => {
  try {
    const officeCodeER = correspondence.receivingDependency.split("_", 1);

    const fullSettledCode = edit
      ? correspondence.id
      : correspondence.communicationChannel +
        CorrespondenceInputType.ER +
        moment().format("YYYY") +
        officeCodeER +
        incrementalCode;

    correspondence.id = fullSettledCode;

    return correspondence;
  } catch (error) {
    dispatch(uiOpenErrorAlert());
    throw new Error("Error save Er");
  }
};

const correspondenceSaveDb = async (
  correspondence: ICorrespondence,
  user: IUserLoggedIn,
  edit: boolean,
  dispatch: any,
  dateNow: any
) => {
  if (!user.idEntity || !user.username) {
    dispatch(uiOpenErrorAlert());
    throw new Error("falta de información del usuario Ir");
  }
  const result = await setCorrespondenceDb(
    correspondence,
    user.idEntity,
    user.id,
    user.username,
    edit,
    dateNow
  );

  if (!result.ok) {
    dispatch(uiOpenErrorAlert());
    throw new Error(
      "Error save db " + correspondence.inputType + " => " + result.data
    );
  }
  return true;
};

const correspondenceSaveFile = async (
  correspondence: ICorrespondence,
  correspondenceTwo: ICorrespondence | null,
  user: IUserLoggedIn,
  code: string
) => {
  if (!user.idEntity || !user.username) {
    throw new Error("falta de información del usuario Ir");
  }
  const attachedDocuments = [...correspondence.digitalSupport];
  const arrayTemp: IFiles[] = [];
  for (let index = 0; index < attachedDocuments.length; index++) {
    const element = attachedDocuments[index];
    if (element.url !== "#") {
      const file = await downloadFileFirebase(element.url, element.fileName);
      arrayTemp.push({
        file,
        fileName: file?.name ?? "",
        url: element.url && element.url !== "" ? element.url : "#",
      });
    } else {
      arrayTemp.push(element);
    }
  }
  correspondence.digitalSupport = [];
  var codeTwo = "";
  if (correspondenceTwo) {
    codeTwo = correspondenceTwo.id;
  }
  const files = await saveFilesFirebase(
    arrayTemp,
    code,
    codeTwo,
    user.id.toString(),
    user.username,
    user.idEntity
  );
  // console.log(files, "files");
  correspondence.digitalSupport = [...files];

  await updateFilesCorrespondence(files, user.idEntity, code);

  return files;
};

const manejoModal = (dispatch: any, tdr?: boolean) => {
  if (!tdr) {
    dispatch(uiCloseModalAdd());
    dispatch(uiCloseModalEdit());
  } else {
    dispatch(uiCloseModalAction());
  }
};

const successMsg = (dispatch: any, edit: boolean) => {
  dispatch(
    setSuccessMsg(edit ? "UpdatedCorrespondence" : "CorrespondenceCreated")
  );
};

const initEmailState = () => {
  const emailStatus: IEmailStatus[] = [
    {
      date: getCurrentDateAndHourColombia(),
      status: "sent",
    },
  ];
  return emailStatus;
};

export const setCorrespondence = (
  correspondence: ICorrespondence | ITenderCorrespondence
): ICorrespondenceActions => ({
  type: Types.setCorrespondence,
  payload: correspondence,
});

export const setActiveCorrespondence = (
  correspondence: ICorrespondence | null
): ICorrespondenceActions => ({
  type: Types.setActiveCorrespondence,
  payload: correspondence,
});

export const startDeleteCorrespondenceFile = (fileName: string) => {
  return async (dispatch: Function, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    const { activeCorrespondence } = (getState() as AppState).correspondence;
    if (activeCorrespondence && user && user.idEntity) {
      const existAppendDoc = activeCorrespondence.appendDocs?.some(
        (doc) => doc.filename === fileName
      );
      const existInDigitalSupport = activeCorrespondence.digitalSupport?.some(
        (doc: any) => doc.fileName === fileName
      );

      let copyActiveCorrespondende = { ...activeCorrespondence };

      if (existInDigitalSupport) {
        const filteredDocs = activeCorrespondence.digitalSupport.filter(
          (el: any) => el.fileName !== fileName
        );
        copyActiveCorrespondende.digitalSupport = [];
        copyActiveCorrespondende.digitalSupport = filteredDocs;
      }

      if (existAppendDoc) {
        const filteredDocs = activeCorrespondence.appendDocs?.filter(
          (el: any) => el.filename !== fileName
        );
        copyActiveCorrespondende.appendDocs = [];
        copyActiveCorrespondende.appendDocs = filteredDocs;
      }

      const { ok } = await deleteFileCorrespondence(user.idEntity, fileName);

      if (ok) {
        await dispatch(
          startSetCorrespondence(copyActiveCorrespondende, true, true)
        );
      }
    }
  };
};

export const startDeleteCorrespondece = (files: any) => {
  return async (dispatch: Function, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    const { activeCorrespondence } = (getState() as AppState).correspondence;
    if (user && user.idEntity && activeCorrespondence) {
      // const ok =true;
      const { ok } = await deleteCommunicationDb(
        user.idEntity,
        activeCorrespondence.id,
        activeCorrespondence.addressee,
        activeCorrespondence.digitalSupport
      );
      if (ok) {
        //dispatch(deleteCorrespondence(activeCorrespondence.id));
        let file: { id: string; url: string } = { id: "", url: "" };
        const response = await create(
          files[0],
          "/correspondence/" + user.idEntity + "/" + files[0].name
        );

        if (response.ok) {
          file.id = response.data.name;
          file.url = response.data.url;
        }

        const { ok } = await createMilestone(
          user.idEntity,
          activeCorrespondence.id,
          firebase.firestore.Timestamp.now(),
          activeCorrespondence.status,
          CorrespondenceStatus.INACTIVE,
          user.id,
          file,
          user.firstLastName ? user.firstName + " " + user.firstLastName : ""
        );
        dispatch(uiCloseModalNull());
        dispatch(setActiveCorrespondence(null));
        dispatch(setSuccessMsg("DeletedCommunication"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("DeletingError"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};

/* const deleteCorrespondence = (
  idCorrespondence: string
): ICorrespondenceActions => ({
  type: Types.deleteCorrespondence,
  payload: idCorrespondence,
}); */

// ****************   CORRESPONDENCIA - Remitente externo    ******************
// cargar remitentes externos
export const startLoadingExternalSender = (idEntity: string) => {
  return async (dispatch: Function) => {
    const ExternalSender = await loadExternalSenders(idEntity);
    if (ExternalSender.length > 0) {
      dispatch(setExternalSenderParamsForm(ExternalSender));
    }
  };
};
// agregar remitente externo
export const startNewExternalSender = (
  form: IExternalSender,
  editUser?: boolean
) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    dispatch(fetchCompanyData(idEntity));

    const { externalSenders, activeExternalSender: active } = getState().users;
    const { users, activeUser } = getState().users;
    const idDoc = form.idDoc ? form.idDoc : null;
    const { companyData } = (getState() as AppState).entityLoad;

    let timeCompany = await getDateToTimeZoneServer(companyData.country);
    form.createAt = timeCompany;

    const existsUser =
      !activeUser && users.find((user: any) => user.document === form.id);

    const existsSender =
      !active &&
      externalSenders.find(
        (user: IExternalSender) => user.id === form.id && user.id.length > 0
      );

    if (existsSender || existsUser) {
      dispatch(setErrorMsg("ExistsSender"));
      dispatch(uiOpenErrorAlert());
    } else {
      const { ok, data } = await addExternalSender(idEntity, idDoc, form);
      if (ok) {
        form.idDoc = data as string;
        dispatch(setActiveExternalSender(form));
        !!active || editUser
          ? dispatch(updateExternalSenderParamsForm(form))
          : dispatch(addExternalSenderParamsForm(form));
        dispatch(uiCloseModalAnswer());
        dispatch(uiCloseModalInfo());
        dispatch(
          setSuccessMsg(
            !!active || editUser
              ? "ExternalSenderUpdated"
              : "ExternalSenderCreated"
          )
        );
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("ErrorExternalSenderCreate"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};

export const searchExternalSendersBySearchTerm = (
  searchTerm: string,
  externalType: string
) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    let results: any[] = [];
    if (externalType === "sender") {
      results = await searchExternalSendersBySearchTermAndIdEntity(searchTerm, idEntity);
      dispatch(searchExternalSenders(results));
    } else {
      results = await searchExternalSendersBySearchTermAndIdEntity(searchTerm, idEntity);
      dispatch(searchExternalAddressees(results));
    }
  };
};

// setear parametros del formulario del remitente
export const setExternalSenderParamsForm = (form: IExternalSender | any) => ({
  type: Types.loadParamsExternalSender,
  payload: form,
});
// adicionar remitente
export const addExternalSenderParamsForm = (form: IExternalSender | any) => ({
  type: Types.addExternalSender,
  payload: form,
});

export const searchExternalSenders = (data: IExternalSender[] | any[]) => ({
  type: Types.searchExternalSenders,
  payload: data,
});

export const searchExternalAddressees = (data: IExternalSender[] | any[]) => ({
  type: Types.searchExternalAddressees,
  payload: data,
});

// editar remitente
export const updateExternalSenderParamsForm = (
  form: IExternalSender | any
) => ({
  type: Types.updateExternalSender,
  payload: form,
});

export const startLoadCorrespondenceInbox = (idUser: number) => {
  return async (dispatch: Function) => {
    const inbox = await getCorrespondenceInbox(idUser.toString());
    if (inbox) {
      dispatch(loadCorrespondeceInbox(inbox));
    }
  };
};
export const loadCorrespondeceInbox = (
  inbox: ICorrespondenceInfo[]
): ICorrespondenceActions => ({
  type: Types.loadCorrespondeceInbox,
  payload: inbox,
});

// CARGAR MILESTONES DE CORRESPONDENCIA
export const startLoadMilestones = (
  idEntity: string | undefined,
  correspondenceId: string
) => {
  return async (dispatch: Function) => {
    const response = await getMilestones(idEntity, correspondenceId);

    dispatch(loadMilestones(response.length > 0 ? response : []));
  };
};
// CARGAR MILESTONES DE EXPEDIENTES
export const startLoadExpedientsMilestones = (
  idEntity: string,
  idExpedient: string,
  fromFilesModule: boolean
) => {
  return async (dispatch: Function) => {
    const response = await getFuidMilestones(
      idEntity,
      idExpedient,
      fromFilesModule
    );

    dispatch(loadMilestones(response.length > 0 ? response : []));
  };
};

export const loadMilestones = (
  milestones: IMilestones[]
): ICorrespondenceActions => ({
  type: Types.loadMilestones,
  payload: milestones,
});

// SUBIR OFICINA CONTRATACION DB

export const startSetContractingOffice = (
  data: IContractingOffice,
  successMessage: string = "ContractingOfficeUpdated",
  errorMessage: string = "ErrorProcedureUpdate"
) => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      data.idEntity = user.idEntity;
      const { ok } = await setContractingOfficeDb(data);
      showMessage(data, dispatch, ok, successMessage, errorMessage);
    }
  };
};

export const startSaveLogo = (data: IContractingOffice, logo: File) => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;

    const imagePath = `logos/${user?.idEntity}/${logo.name}`;
    const urlFile = await uploadFileAsync(logo, imagePath);
    if (urlFile.length > 0) {
      if (data.logoName) {
        await deleteFile(`logos/${user?.idEntity}/${data.logoName}`);
      }
      data.logoUrl = urlFile;
      data.logoName = logo.name;
      await dispatch(
        startSetContractingOffice(data, "logoSuccessfully", "logoError")
      );
    }
  };
};

const showMessage = (
  contractingOffice: IContractingOffice | null,
  dispatch: any,
  isSuccess: boolean,
  successId: string,
  errorId: string
) => {
  if (isSuccess) {
    if (contractingOffice) {
      dispatch(setContractingOffice(contractingOffice));
    }
    dispatch(setSuccessMsg(successId));
    dispatch(uiOpenSuccessAlert());
  } else {
    dispatch(setErrorMsg(errorId));
    dispatch(uiOpenErrorAlert());
  }
};

// CARGAR CONTRACTING OFFICE
export const startLoadContractingOffice = (idEntity: string) =>
  // contractingOffice:string
  {
    return async (dispatch: Function) => {
      const response = await getContractingOffice(idEntity);
      if (response) {
        dispatch(setContractingOffice(response));
      }
      // else {
      // }
    };
  };

export const setContractingOffice = (
  contractingOffice: IContractingOffice
): ICorrespondenceActions => ({
  type: Types.loadContractingOffice,
  payload: contractingOffice,
});

// ****************   CORRESPONDENCIA - Licitaciones    ******************

export const startLoadingTenders = (idEntity: string) => {
  return async (dispatch: Function) => {
    const Tenders = await loadTenders(idEntity);
    dispatch(loadAllTenders(Tenders));
  };
};

export const startSetTender = (tender: ITenders, deleteFile: boolean) => {
  return async (dispatch: any, getState: Function) => {
    // crear licitación
    const { user } = (getState() as AppState).auth;
    const { activeTender } = (getState() as AppState).correspondence;

    if (user && user.idEntity) {
      const id = user.idEntity;
      const parseDate = firebase.firestore.Timestamp.fromDate(
        new Date(tender.closingDate as string)
      );
      const objTender: ITenders = {
        ...tender,
        id: activeTender ? tender.id : tender.id.trim(),
        closingDate: parseDate,
      };
      const { ok } = await addOrUpdateTender(id, objTender);
      if (ok) {
        dispatch(setTender(objTender));
        activeTender
          ? dispatch(uiCloseModalEdit())
          : dispatch(uiCloseModalAdd());
        await dispatch(
          setSuccessMsg(activeTender ? "ProcessUpdated" : "NewTenderAdded")
        );
        dispatch(uiOpenSuccessAlert());
        dispatch(setActiveTender(null));
      } else {
        dispatch(setErrorMsg("ErrorUpdatingProcess"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};
const setTender = (tender: ITenders): ICorrespondenceActions => ({
  type: Types.setTender,
  payload: tender,
});

export const loadAllTenders = (tender: ITenders[]): ICorrespondenceActions => ({
  type: Types.loadTenders,
  payload: tender,
});

export const setActiveTender = (
  active: ITenders | null
): ICorrespondenceActions => ({
  type: Types.setActiveTender,
  payload: active,
});

export const startNewProponent = (proponent: IProponent) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { activeTender: active } = getState().correspondence;
    const { contractingOffice, correspondence: CorrespondenceState } = (
      getState() as AppState
    ).correspondence;

    const existsIdNumber = active.proponents.some(
      (obj: IProponent) => obj.idNumber === proponent.idNumber
    );
    if (contractingOffice) {
      if (existsIdNumber) {
        dispatch(setErrorMsg("ExistsProponent"));
        dispatch(uiOpenAlertExists());
      } else {
        //Crear una correspondencia de licitacion
        //armar el codigo de radicado de la licitacion
        //01 + ER + Año + paramPO codigo + consecutivo
        const currentYearCorrespondece = CorrespondenceState.filter(
          (el) =>
            moment(el.createAt.toDate()).format("YYYY") ===
            moment().format("YYYY")
        );
        const incrementalCode = createIncrementalCode(
          currentYearCorrespondece.length + 1
        );
        const codeOP = contractingOffice.productionOffice.split("_");
        const settledCode =
          CommunicationChannels.SINGLE_WINDOW +
          CorrespondenceInputType.ER +
          moment().format("YYYY") +
          codeOP[0] +
          incrementalCode;
        const finalProponent = { ...proponent };
        finalProponent.settledId = settledCode;
        active.proponents = [...active.proponents, finalProponent];
        //crear la correspondencia

        const { ok: okProponent } = await addOrUpdateTender(idEntity, active);

        //RAZON SOCIAL = REMITENTE
        //DESTINATARIO = QUIEN ESTE A CARGO DE LA OFICINA DE CONTRATACION
        //MANDAR CAMPO isTender para saber cual correspondencia es de licitacion.
        //TIPO DE COMUNICACION = CODIGO DE LA LICITACION
        const corresponceTender: ITenderCorrespondence = {
          id: settledCode,
          externalSender: {
            id: contractingOffice.productionOffice,
            name: proponent.businessName,
          },
          addressee: contractingOffice.responsibleUser,
          isTender: true,
          communicationType: {
            isParam: false,
            option: active.id,
          },
          inputType: CorrespondenceInputType.ER,
          createAt: firebase.firestore.Timestamp.now(),
          subject: `Licitacion No.${active.id}`,
          receivingDependency: contractingOffice.productionOffice,
        };
        const { ok: okCorresTender } = await addCorrespondenceTender(
          idEntity,
          corresponceTender
        );

        if (okProponent && okCorresTender) {
          dispatch(setTender(active));
          dispatch(setCorrespondence(corresponceTender));

          dispatch(uiCloseModalSee());
          dispatch(setSuccessMsg("ProponentAdded"));
          dispatch(uiOpenSuccessAlert());
          dispatch(setActiveTender(null));
        } else {
          dispatch(setErrorMsg("ErrorAddingProponent"));
          dispatch(uiOpenAlertExists());
        }
      }
    }
  };
};

/* ACTION LOAD LABEL SIZE IN CORRESPONDENCE ENTITY*/
export const startLoadLabelSize = (idEntity: string) => {
  return async (dispatch: Function) => {
    const labelSize = await loadLabelSizeDb(idEntity);
    if (labelSize === 0 || labelSize === 1) {
      dispatch(setLabelSizeRedux(labelSize));
    }
  };
};

/* ACTION SAVE LABEL SIZE IN CORRESPONDENCE ENTITY*/
export const startSetlabelSize = (data: ILabelSize) => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      data.idEntity = user.idEntity;
      const { ok } = await setLabelSizeDb(data);
      if (ok) {
        dispatch(setLabelSizeRedux(data.labelSize));
        dispatch(setSuccessMsg("labelSizeUpdated"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("ErrorlabelSizeUpdate"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};

/* ACTION REDUX SAVE LABELSIZE */
export const setLabelSizeRedux = (
  labelSize: number
): ICorrespondenceActions => ({
  type: Types.setLabelSize,
  payload: labelSize,
});

// Cambiar estado de visto de una anotación
export const startReadedAnnotation = (annotation: IAnnotation) => {
  return async (dispatch: Function, getState: Function) => {
    const { user } = (getState() as AppState).auth;

    if (user) {
      if (annotation.sender.id === user.id.toString()) {
        annotation.isReaded = true;
      }

      if (annotation.recipients.includes(user.id.toString())) {
        annotation.recipientsData = annotation.recipientsData.map(
          (el: IRecipients) =>
            el.id.toString() === user.id.toString()
              ? { ...el, isReaded: true }
              : el
        );
      }
      try {
        user.idEntity && (await setAnnotationDb(user.idEntity, annotation));
      } catch (error) {
        console.log(error);
      }
    }
  };
};

//it adds in trd to the correspondence
export const changeTrdCorrtespondenciafile = (data: IClassificationTrdDoc) => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (!user) {
      throw "Falta el usuario ";
    }

    if (!data.FileClasification || data.FileClasification.length <= 0) {
      throw "Falta selecionar archivos ";
    }

    let classificationTrd: IClassificaitionTrd = {
      officeProduction: data.officeProduction,
      serie: data.serie,
      subserie: data.subserie,
      typeDocument: data.typeDocument,
      createdAt: firebase.firestore.Timestamp.now(),
      userId: user.id.toString(),
    };

    let getCorrespondence = await geCorrespondenceById(
      data.CorrespondenceActive.idEntity,
      data.CorrespondenceActive.id
    );

    let digitafile = setTrdDigitalSupportFiles(
      data,
      getCorrespondence,
      classificationTrd
    );
    let append = setTrdAppendDocsFiles(
      data,
      getCorrespondence,
      classificationTrd
    );

    data.CorrespondenceActive.digitalSupport = digitafile;
    data.CorrespondenceActive.appendDocs = append;

    dispatch(setActiveCorrespondenceDocManagment(data.CorrespondenceActive));
    dispatch(uiCloseModalAction());
  };
};

export const setFilesCorespondence = (data: IClassificationTrdDoc) => {
  return async (dispatch: any, getState: Function) => {};
};

function setTrdDigitalSupportFiles(
  data: IClassificationTrdDoc,
  getCorrespondence: any,
  classificationTrd: IClassificaitionTrd
) {
  let digitalSupport: IClassificationTrdDigitalSupport[] = [];
  const fileNamesSet = new Set(
    data.FileClasification.filter((doc) => doc.location === "digitalSupport") // Filtra por location
      .map((doc) => doc.fileName) //  Extrae solo los fileName
  );
  if (fileNamesSet.size > 0) {
    // Filtra los elementos
    const uniqueFiles = getCorrespondence.digitalSupport.filter(
      (doc: IFiles) => !fileNamesSet.has(doc.fileName)
    );

    const uniqueFilesTrd = getCorrespondence.digitalSupport.filter(
      (doc: IFiles) => fileNamesSet.has(doc.fileName)
    );

    uniqueFilesTrd.forEach((element: any) => {
      let trdData = element?.trdCode;

      trdData = trdData
        ? Array.isArray(trdData)
          ? [...trdData, classificationTrd]
          : [trdData, classificationTrd]
        : [classificationTrd];
      element.trdCode = trdData;
    });

    digitalSupport = [...uniqueFiles, ...uniqueFilesTrd];

    FilesCorrespondencedigitalSupportTrd(
      digitalSupport,
      data.CorrespondenceActive.idEntity,
      data.CorrespondenceActive.id
    );

    return digitalSupport;
  } else {
    return getCorrespondence.digitalSupport;
  }
}

function setTrdAppendDocsFiles(
  data: IClassificationTrdDoc,
  getCorrespondence: any,
  classificationTrd: IClassificaitionTrd
) {
  let digitalSupport: IClassificationTrdDigitalSupport[] = [];
  const fileNamesSet = new Set(
    data.FileClasification.filter((doc) => doc.location === "AppendDocs") // Filtra por location
      .map((doc) => doc.fileName) //  Extrae solo los fileName
  );
  if (fileNamesSet.size > 0) {
    // Filtra los elementos que no estan contenidos en AppendDocs
    const uniqueFiles = getCorrespondence.appendDocs.filter(
      (doc: IFilesAppendDocs) => !fileNamesSet.has(doc.filename)
    );
    // Filtra los elementos que estan contenidos en AppendDocs
    const uniqueFilesTrd = getCorrespondence.appendDocs.filter(
      (doc: IFilesAppendDocs) => fileNamesSet.has(doc.filename)
    );

    uniqueFilesTrd.forEach((element: any) => {
      let trdData = element?.trdCode;

      trdData = trdData
        ? Array.isArray(trdData)
          ? [...trdData, classificationTrd]
          : [trdData, classificationTrd]
        : [classificationTrd];
      element.trdCode = trdData;
    });

    digitalSupport = [...uniqueFiles, ...uniqueFilesTrd];

    FilesCorrespondenceAppendDocsTrd(
      digitalSupport,
      data.CorrespondenceActive.idEntity,
      data.CorrespondenceActive.id
    );

    return digitalSupport;
  } else {
    return getCorrespondence.appendDocs;
  }
}
